export default "__VITE_ASSET__BbWPqs3D__"